import TabComponent from './tab.component';

let TabModule = angular.module('tab', [
])
.directive('tab', TabComponent)
.filter('sanitize', ['$sce', ($sce) => {
  return (htmlCode) => {
    return $sce.trustAsHtml(htmlCode);
  };
}]);

export default TabModule;



// WEBPACK FOOTER //
// ./src/components/tab/tab.js